import { Style } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Icon } from '@app/components/core/icon/Icon'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { Card } from './Card'

export interface BlogCardProps {
  image: string
  meta?: string
  title: string
  intro?: string
  orientation?: 'vertical' | 'horizontal'
  style?: Style
  imageStyle?: Style
  titleStyle?: Style
  introStyle?: Style
  to: string
}

export const BlogCard = ({
  image,
  meta,
  title,
  intro,
  orientation = 'vertical',
  style,
  imageStyle,
  titleStyle,
  introStyle,
  to,
}: BlogCardProps) => {
  return (
    <Card
      data-testid="blog-card"
      image={image}
      imageStyle={imageStyle}
      title={title}
      titleStyle={titleStyle}
      padded
      orientation={orientation}
      style={style}
      to={to}
    >
      {meta && (
        <Card.Meta>
          <Text.Small
            data-testid="text-small"
            style={{
              color: 'var(--brand-primary)',
              fontSize: '0.875rem',
              fontWeight: '500',
              margin: 0,
              textTransform: 'uppercase',
            }}
          >
            {meta}
          </Text.Small>
        </Card.Meta>
      )}
      {intro && (
        <Text.Medium
          style={{
            ...introStyle,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {intro}
        </Text.Medium>
      )}
      <Card.Actions>
        <Icon
          icon={faArrowRight}
          size="small"
          style={{
            marginLeft: 'auto',
            color: 'var(--brand-secondary)',
            background: 'transparent',
            border: '2px solid var(--brand-secondary)',
            borderRadius: '50%',
            padding: '0.25rem',
          }}
        />
      </Card.Actions>
    </Card>
  )
}
